import type { Unsaved } from '~/types/Unsaved'
import type { Workspace } from '~/types/Workspace'

// What a newly created workspace is sent with. The grading prompt fields are
// deliberately absent: the API applies its own per-environment column defaults,
// and sending nulls would write over them while sending literals would ignore
// the staging-specific default the migration sets.
export const workspaceCreateDefault = {
  exclusions: [],
  frequentlyUsedTerms: [],
  industryDescription: '',
  title: '',
  values: [],
  workingAtmosphere: '',
  createdBy: '',
  profileImageUrl: null,
  submissionTestGradingModelId: null,
  useGradingVariabilityDetection: false,
}

// The full shape, used to fill gaps in what the server returns.
export const workspaceDefault: Required<Unsaved<Workspace>> = {
  ...workspaceCreateDefault,
  gradingSystemPrompt: null,
  gradingOverrideSystemPrompt: null,
  pointsGradingSystemPrompt: null,
  gradingSummaryFeedbackSystemPrompt: null,
}
